export default function InvoiceFilters({ 
  fromDate, 
  setFromDate, 
  toDate, 
  setToDate, 
  onSearch, 
  onClear,
  searchCode,        
  setSearchCode,     
  onSearchByCode,
  onClearCode,
}) {
  // ✅ Función para formatear fecha sin problema de zona horaria
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    // Separar año, mes, día directamente del string
    const [year, month, day] = dateString.split('-');
    
    // Crear fecha en formato legible
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString('es-SV', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="invoice-filters">
      <div className="filters-row">
        <div className="form-group">
          <label className="form-label">📅 Fecha Inicio</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">📅 Fecha Fin</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="filters-actions">
          <button className="btn btn-primary" onClick={onSearch}>
            🔍 Buscar
          </button>
          <button className="btn btn-secondary" onClick={onClear}>
            🔄 Limpiar
          </button>
        </div>
      </div>
      <div className="filters-row" style={{ marginTop: '12px' }}>
  <div className="form-group" style={{ flex: 1 }}>
    <label className="form-label">🔎 Buscar por Código de Generación</label>
    <input
      type="text"
      className="form-control"
      placeholder="Ej: A1B2C3D4-E5F6-..."
      value={searchCode}
      onChange={(e) => setSearchCode(e.target.value)}
      onKeyDown={(e) => e.key === 'Enter' && onSearchByCode()}
    />
  </div>
  <div className="filters-actions" style={{ alignSelf: 'flex-end' }}>
<button className="btn btn-primary" onClick={onSearchByCode}>
  🔍 Buscar Factura
</button>
<button className="btn btn-secondary" onClick={onClearCode}>
  🔄 Limpiar
</button>
  </div>
</div>

      {fromDate && toDate && (
        <div className="alert alert-info">
          <span>
            📊 Buscando facturas desde <strong>{formatDate(fromDate)}</strong> hasta{" "}
            <strong>{formatDate(toDate)}</strong>
          </span>
        </div>
      )}
    </div>
  );
}